import React, { useState } from "react";
import {

  LinhaVertical,
  Space,
  Title,
  DivImg,
  Img,
} from "./style";
import { useTranslation } from "react-i18next";
import { BeatLoader } from "react-spinners";
import Footer from "../../../components/footer/footer";
import logo from "../../../assets/images/new-logo.png";

import {
  Formik,
  Form,
  FormikHelpers,
} from "formik";

import ButtonSelect from "../../../components/button-select/ButtonSelect";
import { useAuth } from "../../../context/AuthContext";
import registerValidationSellerPF from "../../../utils/validation/registerValidationSellerPF";
import registerValidationSellerPJ from "../../../utils/validation/registerValidationSellerPJ";
import { baseBuyer } from "../../../utils/server/api";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import StepBuyerBasicInfo from "@/components/register-user/buyer/StepBuyerBasicInfo";
import StepBuyerAddress from "@/components/register-user/buyer/StepBuyerAddress";
import StepBuyerAccess from "@/components/register-user/buyer/StepBuyerAccess";
import { useNavigate } from "react-router-dom";

const steps = ["Informações", "Endereço", "Acesso"];

export default function RegisterBuy() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState<number>(1);
  const [isLoading, setIsLoading] = useState(false);
  const { registerError } = useAuth();
  const { t } = useTranslation();

  const handleSelectChange = (option: number) => {
    setSelectedOption(option);
  };

  const initialValues = {
    type: selectedOption,
    business_name: "",
    corporate_name: "",
    document: "",
    cnpj: "",
    state_registration: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    zip_code: "",
    street: "",
    house_number: "",
    complement: "",
    neighborhood: "",
    federal_unity: "",
    city: "",
    full_address: "",
    lat: "",
    lng: "",
  };

  const handleSubmit = async (
    values: typeof initialValues,
    actions: FormikHelpers<typeof initialValues>
  ) => {
    let data = {};
    if (values.type === 1) {
      data = {
        document_type: "cpf",
        user_type: "buyer",
        fullname: values.business_name,
        cpf: values.document.replace(/[^0-9]/g, ""),
        phone: values.phone.replace(/[^0-9]/g, ""),
        email: values.email,
        password: values.password,
        zip_code: values.zip_code,
        street: values.street,
        house_number: values.house_number,
        complement: values.complement,
        neighborhood: values.neighborhood,
        federal_unity: values.federal_unity,
        city: values.city,
        address: values.full_address,
        lat: values.lat,
        lng: values.lng,
      };
    }

    if (values.type === 2) {
      data = {
        document_type: "cnpj",
        user_type: "buyer",
        fullname: values.business_name,
        company_name: values.corporate_name,
        cnpj: values.cnpj.replace(/[^0-9]/g, ""),
        state_registration: values.state_registration,
        phone: values.phone.replace(/[^0-9]/g, ""),
        email: values.email,
        password: values.password,
        zip_code: values.zip_code,
        street: values.street,
        house_number: values.house_number,
        complement: values.complement,
        neighborhood: values.neighborhood,
        federal_unity: values.federal_unity,
        city: values.city,
        address: values.full_address,
        lat: values.lat,
        lng: values.lng,
      };
    }

    setIsLoading(true);
    await axios
      .post(`${baseBuyer}/create`, data)
      .then((response) => {
        toast.success(t("successfully"), {
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(function () {
          navigate("/loginBuy");
        }, 3000);
      })
      .catch((error: any) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const errors = error.response.data.errors;

          Object.keys(errors).forEach((field) => {
            errors[field].forEach((errorMessage: string) => {
              toast.error(t(errorMessage), {
                position: toast.POSITION.TOP_CENTER,
              });
            });
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="flex-1 bg-[url('/background-comprador.png')] bg-cover bg-no-repeat">
        <div className="flex items-start">
          <Space onClick={() => navigate("/")}>
            <DivImg>
              <Img src={logo} alt="Logo da ecolife" />
            </DivImg>
          </Space>
          <LinhaVertical />
          <div className="flex flex-col justify-center items-center w-[50%] py-10">
            <div className="!shadow-2xl rounded-2xl backdrop-blur-sm bg-white/60 flex flex-col items-center p-6">
              <Title>{t("comment-buyer")}</Title>
              <ButtonSelect onSelectChange={handleSelectChange} options="all" />

              <Formik
                initialValues={initialValues}
                validationSchema={
                  selectedOption === 1
                    ? registerValidationSellerPF
                    : registerValidationSellerPJ
                }
                onSubmit={handleSubmit}
                enableReinitialize={true}
              >
                <Form>
                  {step === 0 && (
                    <StepBuyerBasicInfo
                      selectedOption={selectedOption}
                      registerError={[]}
                    />
                  )}
                  {step === 1 && <StepBuyerAddress />}
                  {step === 2 && <StepBuyerAccess />}

                  <div className="mt-6 flex justify-between">
                    {step > 0 && (
                      <button
                        className="!bg-amber-500 !px-4 !py-2 !text-white !font-medium rounded-sm"
                        type="button"
                        onClick={() => setStep((s) => s - 1)}
                      >
                        Voltar
                      </button>
                    )}
                    {step === steps.length - 1 ? (
                      <button
                        className="!bg-[#50700F] !px-4 !py-2 !text-white !font-medium rounded-sm"
                        type="submit"
                      >
                        {isLoading ? (
                          <BeatLoader className="spinner" color="white" />
                        ) : (
                          t("register")
                        )}
                      </button>
                    ) : (
                      <button
                        className="!bg-[#2196F3] !px-4 !py-2 !text-white !font-medium rounded-sm"
                        type="button"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                          e.preventDefault();
                          setStep((s) => s + 1);
                        }}
                      >
                        Próximo
                      </button>
                    )}
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
      <Footer />
    </>
  );
}
